import config from '../../config'
import qs from 'qs'
import axios from 'axios'

type QueryObject = {
  asOfDate?: string
  personnelId?: number
  trainingGroupId?: number
}

const getTrainingComplianceAnnualCompactReport = (queryObject: QueryObject | undefined): any => {
  const queryString = qs.stringify({ ...queryObject }, { addQueryPrefix: true, skipNulls: true })

  const url = `${config.baseUrl}/training/compliance/annual/compact-pdf${queryString}`

  return axios.get(url, {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
  })
}

export default getTrainingComplianceAnnualCompactReport
